import { defer, pickBy, omit } from 'lodash';
import store from 'store';
import CheckoutPage from 'navigation/pages/CheckoutPage';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
class CheckoutAddress extends CheckoutPage {
    bindEvents(add = true) {
        super.bindEvents(...arguments);
        const emitterMethod = bindEmitterMethod(add);
        const method = bindMethod(add);
        this.modules.radioGroup.forEach(r => r[emitterMethod]('change', this.onMethodChange, this));
        this.refs.webstoreSwitcher[method]('click', this.onWebstoreSwitcherClick);
        store.panel.toggleListener(add, this.onPanelChange, this);
        if (add)
            this.onMethodChange();
    }
    onWebstoreSwitcherClick(event) {
        store.drawer.set('webstore-switcher');
    }
    onPanelChange = (panelValue) => {
        if (panelValue === null)
            this.parent?.refreshPage();
    };
    bindModules() {
        super.bindModules();
        const { form } = this.modules;
        const validations = Object.assign({}, form.validations);
        const billingValidation = pickBy(validations, (v, k) => !!~k.indexOf('billing___'));
        const deliveryValidation = pickBy(validations, (v, k) => !!~k.indexOf('delivery___'));
        const baseValidation = omit(validations, [...Object.keys(billingValidation), ...Object.keys(deliveryValidation)]);
        this.validations = {
            default: validations,
            billing: billingValidation,
            delivery: deliveryValidation,
            base: baseValidation
        };
    }
    onMethodChange() {
        defer(() => {
            const data = this.modules.radioGroup.reduce((memo, radio) => {
                memo[radio.name] = radio.value;
                return memo;
            }, {});
            const schema = { ...this.validations.base };
            const { form } = this.modules;
            if (data.address_choice === 'new')
                Object.assign(schema, this.validations.delivery);
            if (data.same_address === '0')
                Object.assign(schema, this.validations.billing);
            form.updateSchema(schema);
            setTimeout(() => form.quickValid(), 10);
        });
    }
    resize() {
        super.resize();
    }
    flush() {
        super.flush();
    }
}
export default CheckoutAddress;
